export const buttonsTranslationEN = {
  buttons: {
    "save": "Save",
    "cancel": "Cancel",
    "new": "New",
    "close": "Close",
    "exit": "Exit",
    "back": "Back",
  }
}